export default __webpack_public_path__ + "static/media/thumbnail.0abdf62c.png";